import {AutoMap} from '@automapper/classes';
import {TCommonModel, TListCommonModel} from './t-common-model';

export abstract class TBaseModel extends TCommonModel {
  @AutoMap()
  id!: string;
  @AutoMap()
  createdOn!: Date;
  @AutoMap()
  modifiedOn!: Date | null;
}

export abstract class TListBaseModel extends TListCommonModel {
  @AutoMap()
  id!: string;
  @AutoMap()
  createdOn!: Date;
}
